<shrd-uic-preloader [active]="!!userData.isLoading" immediate size="x-small" class="bg-white"></shrd-uic-preloader>
<shrd-pf-ui-meta-nav-item>
  <a
    *ngIf="!userData.isLoggedIn; else loggedInTpl"
    [href]="inHostContext ? '#overlay/login' : (loginUrl$ | async)"
    shrdUicButton
    variant="tertiaryMinorBorderless"
    class="text-primary my-0 login-link meta-nav-item"
    [class.rememberme-active]="inHostContext"
    [attr.data-sso]="inHostContext || null"
    (click)="loggedInButtonClicked()"
    [shrdUtcTrackEvent]="{
      category: 'SiteOperations',
      action: 'Login',
      label: 'Top Menu|Open|SSO'
    }"
  >
    <span
      shrdPfUiMaxWidth
      [@labelSlide]="true"
      [@.disabled]="!inHostContext"
      class="visually-hidden-sm-down no-truncate"
    >
      {{ 'header.account.login' | i18next }}
    </span>
    <shrd-uic-svg-icon icon="profile" *ngIf="showProfileIcon"></shrd-uic-svg-icon>
  </a>
  <ng-template #loggedInTpl>
    <ng-container *ngTemplateOutlet="loggedUserTemplateRef"></ng-container>
  </ng-template>
</shrd-pf-ui-meta-nav-item>
